/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AufgabeAnlegenRequest { 
    vorlage_aufgabe_id: string;
    optional_standard_aktiviert?: boolean;
    bilder_ids?: Array<string>;
    ist_eskalation_fix?: boolean;
    beschreibung?: string;
    erinnerung_fix_wochentag?: number;
    erinnerung_relativ_minuten?: number;
    erinnerung_relativ_tage?: number;
    erinnerung_uhrzeit_fix_minuten?: number;
    erinnerung_uhrzeit_fix_stunden?: number;
    eskalation_fix_wochentag?: number;
    eskalation_relativ_minuten?: number;
    eskalation_relativ_tage?: number;
    eskalation_uhrzeit_fix_minuten?: number;
    eskalation_uhrzeit_fix_stunden?: number;
    ist_erinnerung_aktiv?: boolean;
    ist_erinnerung_uhrzeit_fix?: boolean;
    ist_erinnerung_wochentag_fix?: boolean;
    ist_eskalation_aktiv?: boolean;
    ist_eskalation_an_abarbeiter_aktiv?: boolean;
    ist_eskalation_an_freigeber_checkliste_aktiv?: boolean;
    ist_eskalation_an_freigeber_funktionsbereich_aktiv?: boolean;
    ist_eskalation_an_veranstaltungsleiter_aktiv?: boolean;
    ist_eskalation_uhrzeit_fix?: boolean;
    ist_eskalation_wochentag_fix?: boolean;
    ist_optional?: boolean;
    phase_id: string;
    reihenfolge?: number;
    titel: string;
    referenz_zeitpunkt?: string;
    ist_veranstaltungsrelevant?: boolean;
    relation?: string;
    aufgabe_id: string;
    checkliste_id: string;
    funktionsbereich_id: string;
    veranstaltung_id: string;
}

